export const HEADER_API_KEY = 'X-Podo-Api-Key'
export const MAX_BODY_BYTES = 1_048_576 // 1MB

export const DEFAULT_FLUSH_AT = 20
export const DEFAULT_FLUSH_INTERVAL = 5_000
export const DEFAULT_MAX_RETRIES = 3
export const MAX_FLUSH_AT = 50

export const RETRY_BASE_DELAY = 1_000
export const RETRY_429_DELAY = 5_000

export const STORAGE_KEY_ANON_ID = 'podo_anon_id'
